import React, { useState } from "react";
import { isHoppyOrGamification } from "@util/Scripts";
import { ListScripts } from "./listScripts";
import { Dropdown, Button } from "../../../BP2Components";
import "../list.less";

const ListSerieSelector = ({ selectedSerieObj, handleSerieChange, listWidgetSeries }) => {
   const [isDropdownOpen, setIsDropdownOpen] = useState(false);

   const contentDropDown = ListScripts.getOnlyNotTechnicalSeries(listWidgetSeries).map((serie) => ({
      id: serie.id,
      name: serie.name
   }));

   return (
      <div className="list-serie-btns">
         {listWidgetSeries &&
            ListScripts.getOnlyNotTechnicalSeries(listWidgetSeries).length > 1 &&
            ListScripts.getOnlyNotTechnicalSeries(listWidgetSeries).map((serie, index) => {
               if (isHoppyOrGamification()) {
                  return (
                     <Button
                        key={serie.id}
                        id={serie.id}
                        className="list-serie-single-btn"
                        style={{
                           backgroundColor: selectedSerieObj.name === serie.name ? "#CCC" : ""
                        }}
                        onClick={() => handleSerieChange(serie.id)}
                     >
                        {serie.name}
                     </Button>
                  );
               } else {
                  if (index === 0) {
                     return (
                        <Button onClick={() => setIsDropdownOpen(!isDropdownOpen)}>
                           {selectedSerieObj.name}
                           <Dropdown
                              items={contentDropDown}
                              isOpen={isDropdownOpen}
                              setIsOpen={setIsDropdownOpen}
                              onOptionClick={({ id }) => handleSerieChange(id)}
                           />
                        </Button>
                     );
                  }
               }
            })}
      </div>
   );
};

export default ListSerieSelector;
